// frontend/views/SecureWrapperView.tsx
import React from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuthStore } from '@/modules/auth/stores/auth-store';
import { useMessage } from '@/shared/hooks/useMessage';
import { AuthProvider } from '@/modules/auth/context/AuthContext';

export const SecureWrapperView: React.FC = () => {
    const { user, isLoading, refreshUser } = useAuthStore();
    const navigate = useNavigate();
    const location = useLocation();
    const message = useMessage();
    const [authChecked, setAuthChecked] = React.useState(false);

    React.useEffect(() => {
        let mounted = true;

        refreshUser()
            .catch(() => undefined)
            .finally(() => {
                if (mounted) {
                    setAuthChecked(true);
                }
            });

        return () => {
            mounted = false;
        };
    }, [refreshUser]);

    React.useEffect(() => {
        if (!authChecked || isLoading) {
            return;
        }
        if (user?.changePassword && location.pathname !== '/user/change-password') {
            message.info('Please change your password');
            navigate('/user/change-password', { replace: true });
        }
    }, [user, navigate, message, location.pathname, authChecked, isLoading]);

    if (isLoading || !authChecked) {
        return (
            <div className="flex items-center justify-center h-screen">
                <Spin size="large" />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    return (
        <AuthProvider>
            <Outlet />
        </AuthProvider>
    );
};